import React from 'react';
import './Plashka.css';

const Plashka = (props) => {
    return (
        <div className="plashka_wrap">
            <div className="plashka container">
                <h4 className='plashka_title'>The Web3 invites both Web3 natives and travelers from Web2 - together we will build the future of the Internet!</h4>
            </div>
        </div>
    );
};

export default Plashka;